import type { CRegisterationToNewslettersTranslations } from "./pl";

export const en: CRegisterationToNewslettersTranslations = {
  noConfig: "No form configuration data.",
  noCategorys: "There are no newsletter categories to which you can subscribe.",

  topInfo: "We invite you to subscribe to our newsletter.",
  topInfo2: "What topics would you like to receive information about?",
  categoriesHeader: "Newsletter categories",
  additionalDataHeader: "Subscriber details",
  loggedInIntro: (email: string) =>
    email
      ? `You are setting newsletter categories for your account (${email}) - not for the address entered earlier. Select the ones you want to receive.`
      : "Manage your account's subscriptions - select the categories you want to receive.",
  save: "Sign up",
  saveLoggedIn: "Update subscriptions",
  saving: "Saving...",
  emailLabel: "E-mail",

  validation: {
    requiredField: (label: string) => `The "${label}" field is required.`,
    selectCategory: "Please select at least one category.",
    invalidEmail: "Invalid email address.",
    notAcceptedRegulamin: "Regulations not accepted.",
    notAcceptedPersonalData: "You must consent to the processing of your personal data.",
    notAcceptedMarketing: "Shipping consent has not been agreed.",
  },

  status: {
    waitBeforeSubmit: (seconds: number) =>
      `Please wait another ${seconds} seconds before submitting.`,
    rateLimit: "Too many attempts from this IP address. Try again in a moment.",
    subscribeFailed: "Failed to subscribe to the newsletter.",
    subscribeSuccess: "You have been subscribed to the newsletter, thank you!",
    updateSuccess: "Your subscriptions have been updated.",
    networkError: (message: string) => `Network error: ${message}`,
    networkErrorGeneric: "Network error while saving.",
  },
};
